import React, { useEffect, useState } from "react";
import PageHeader from "../Common/PageHeader";
import MapsIcon from "../../assets/icons/mapping.svg2";
import MyMap from "./MyMap";
import AssetsLinks from "../Assets/AssetsLinks";
import MapFilters from "./MapFilters";
import WeatherAlerts from "./WeatherAlerts";
import Clusters from "./Clusters";
import { AbsoluteLoadingIndicator } from "../Common/FullScreenLoadingIndicator";
import WeatherForecasts from "./WeatherForecasts";
import { EventOverlay } from "./MapPopUps";
import HelpButton from "../HelpContent/HelpButton";

export default function MapPage() {
  const [filters, setFilters] = useState<any>({});
  const [weatherForecastDates, setWeatherForecastDates] = useState<string[]>(
    []
  );
  const [loading, setLoading] = useState(false);
  const [overlay, setOverlay] = useState({
    show: false,
    position: { x: 0, y: 0 },
    content: <>Overlay</>,
    assetUuid: "",
    contactUuid: "",
    eventUuid: "",
  });

  useEffect(() => {
    setOverlay((p) => ({ ...p, show: false }));
  }, [filters]);
  return (
    <div className="mb-n5">
      <div className="vh-100 py-2 position-relative">
        {loading && <AbsoluteLoadingIndicator loading={loading} />}
        <MyMap
          isPage
          closeOverlay={() => setOverlay({ ...overlay, show: false })}
        >
          <div>
            <MapFilters
              onChange={setFilters}
              setOverlay={setOverlay}
              setLoading={setLoading}
              weatherForecastDates={weatherForecastDates}
              beforeTimeline={
                filters.weatherForecastFilters?.isForecast ? (
                  <WeatherForecasts
                    filters={filters.weatherForecastFilters}
                    setOverlay={setOverlay}
                    setLoading={setLoading}
                    setWeatherForecastDates={setWeatherForecastDates}
                  />
                ) : (
                  <></>
                )
              }
            />
            {filters.weatherFilters?.isWeather ? (
              <WeatherAlerts
                filters={filters.weatherFilters}
                setOverlay={setOverlay}
                setLoading={setLoading}
              />
            ) : filters.weatherForecastFilters?.isForecast ? (
              <></>
            ) : (
              <Clusters
                filters={filters}
                setLoading={setLoading}
                showSelection
                // showPopup={(cluster, e, map) => {
                // if (cluster.IsCluster) {
                //   setOverlay({
                //     show: true,
                //     position: { x: e.domEvent.x, y: e.domEvent.y },
                //     content: <ClusterPopUp map={map} cluster={cluster} />,
                //     assetUuid: "",
                //     contactUuid: "",
                //   });
                // } else {
                //   const location = cluster.Item || cluster;
                // setOverlay({
                //   show: true,
                //   position: { x: e.domEvent.x, y: e.domEvent.y },
                //   assetUuid: "",
                //   contactUuid: "",
                //   eventUuid: "",
                //   content: (
                //     <div className="bg-purple-gradient p-2 rounded">
                //       <EventOverlay eventUuid={cluster.Item.EventUuid} />
                //     </div>
                //   ),
                // });
                // }
                // }}
                setOverlay={setOverlay}
              />
            )}
          </div>
        </MyMap>
        {overlay.show && (
          <div
            className="position-fixed"
            style={{
              top: overlay.position.y - 20,
              left: overlay.position.x + 20,
              zIndex: 1000,
            }}
          >
            {overlay.content}
          </div>
        )}
      </div>
    </div>
  );
}
